module.exports = __webpack_public_path__ + "img/pmg-logo.ae11443b.png";